import { RouteConfig } from 'vue-router'

const Home = () => import('../views/Home.vue')

export const homeRoute: RouteConfig = {
  path: '/home',
  name: 'home',
  component: Home,
  redirect: 'workbench',
  meta: {
    title: '首页',
  },
}

export default [homeRoute]
